<template>
    <div class="historyList">
        <div class="top">
            <span class="icon" @click="goback"></span>
            <span class="title">收入明细</span>
        </div>

        <div class="time-box">
            <div class="myDate">
                <span class="mytime">{{ queryParams.months }}</span>
                <van-cell is-link @click="showPopup" class="icon"></van-cell>
                    <van-popup
                    :close-on-click-overlay=false
                     v-model="show" position="bottom" :style="{ height: '40%' }">
                       <van-datetime-picker
                            type="year-month"
                            :min-date="minDate"
                            :max-date="maxDate"
                            :formatter="formatter"
                            title="选择日期"
                            @confirm="confirm($event)"
                            @cancel="cancel()"
                            />
                    </van-popup>
            </div>

            <div class="myDate">
                <span class="ice-text">月收入</span>
                <span class="rnum">￥{{ totalAmount }}</span>
            </div>

            <div class="myDate">
                <span class="ice-text">月条数</span>
                <span class="bnum">{{ totalCount}}条</span>
            </div>
        </div>

        <div class="content" v-if="historyArray.length==0">
            <div class="img-box">
                <img src="../assets/Group167.png" alt="">
            </div>
            <div class="null-text">
                <span>本月暂无收入,立刻去</span>
                <span class="grenn-txt">推广赚钱</span>
            </div>
        </div>

        <div class="con-list" v-for="item in historyArray" :key="item.id">
            <income-list :historyArray="item"></income-list>
        </div>

    </div>
</template>

<script>
import Vue from 'vue'
import incomeList from '@/components/incomeList'
import agent from '@/agents/record'
export default Vue.extend({
    name:'historyList',
    components:{
       incomeList 
    },
    data(){
        return {
            show: false,
            minDate: new Date(2020, 0, 1),
            maxDate: new Date(2025, 10, 1),
            currentDate: new Date(),
            historyArray:[],
            totalCount: 0,
            totalAmount: 0,

            queryParams: {
                months: '',
            },
        }
    },
    created(){
        this.get_current_year_month()
        this.getData()
    },
    methods:{
        getData() {
            this.findItems()
        },
        isFloat(n) {
           return /^\d+(\.\d+)?$/.test(n);

        },
        async findItems() {
            const { ok, message, data } = await agent.find(this.queryParams)
            if (!ok || !data) {
                return
            }

            this.historyArray = data.items
            this.totalCount = data.totalCount
            if(this.isFloat(data.totalAmount)) {
                this.totalAmount = data.totalAmount.toFixed(2)
            }
        },
        get_current_year_month () {
            const today = new Date()
            let month = today.getMonth() + 1
            if (month < 10) {
                month = '0' + month
            }
            this.queryParams.months = today.getFullYear() + "-" + month
        },
        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } else if (type === 'month') {
                return `${val}月`;
            }
            return val;
        },
        showPopup() {
            this.show = true;
        },
        goback(){
          this.$router.go(-1)
        },
        confirm(event) {
            this.show=false
            let month = event.getMonth() + 1
            if (month < 10) {
                month = '0' + month
            }
            this.queryParams.months = event.getFullYear() + "-" + month
            this.getData()
            window.scrollTo(0,0);
        },
        cancel(){
            this.show=false
        }
    }
})
</script>

<style lang="scss" scoped>
.historyList {
    width: 100%;
    .top {
        width: 100%;
        height: 56px;
        position: sticky;
        top: 0px;
        // margin-top: 24px;
        background-color: white;
        z-index: 2;
        .icon {
            display: block;
            width: 25px;
            height: 25px;
            background-image: url('../assets/close.png');
            background-size: 25px 25px;
            position: absolute;
            left: 15px;
            top: 50%;
            margin-top: -12px;
        }
        .title {
            display: block;
            font-weight: 500;
            font-size: 16px;
            color:black;
            text-align: center;
            line-height: 56px;
        }
    }
    .time-box {
    width: 100%;
    height: 56px;
    display: flex;
    padding: 0px 16px;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    border-bottom:1px solid rgb(231,231,231);
    position: sticky;
    top: 56px;
    background-color: white;
    z-index: 999;
    .myDate {
        display: flex;
        .mytime {
            font-weight: 400;
            font-size: 12px;
            color:#23262F;
            line-height: 20px;
        }
        .ice-text {
            font-weight: 400;
            font-size: 12px;
            color: #BDBEC1 ;
            margin: 0px;
        }
        .rnum {
            color: #EE6236;
            font-size: 12px;
            margin-left: 9px;
        }
        .bnum {
            color: #23262F;
            font-size: 12px;
            font-weight: 400;
            margin-left: 8px;
        }
        .icon {
            width: 20px;
            height: 20px;
            display: block;
            background-image: url('../assets/zankai.png');
            background-size: 20px 20px;
            margin-left: 10px;
            background-repeat: no-repeat;
        }
        .van-icon-arrow:before { 
            content: "";
        }
        
    }
}
.content {
    width: 100%;
    height: calc(100vh - 112px);
    background-color: #F7F8F9;
    .img-box {
        width: 225px;
        height: 201px;
        margin: 0 auto;
        padding-top: 90.53px;
        img {
           width: 225px;
            height: 201px; 
        }
    }
    .null-text {
        width: 100%;
        text-align: center;
        height: 40px;
        margin: 0 auto;
        font-size: 14px;
        margin-top: 39.88px;
        span {
            display: block;
            color: rgb(196,197,200);
        }
        .grenn-txt {
            display: block;
            color: rgb(88,189,125);
            text-align: center;
        }
    }
}
}
</style>